module.exports = __webpack_public_path__ + "img/SC-PROOF-4999.373b4f1a.png";